import React, { useState, useEffect } from "react";
import "./novaSenha.css";
import "../../styles/bg-responsive.css";
import "../../styles/auth-logo.css";
import sbfLogo from "../../assets/SBF-Logo-1.png";
import { toast } from "react-toastify";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { FaEye, FaEyeSlash, FaLock, FaSpinner, FaCheck } from "react-icons/fa";
import api from "../../services/axios";

const NovaSenha = () => {
    const navigate = useNavigate();
    const { token } = useParams();
    const [searchParams] = useSearchParams();

    const [email, setEmail] = useState("");
    const [novaSenha, setNovaSenha] = useState("");
    const [confirmarSenha, setConfirmarSenha] = useState("");
    const [showNovaSenha, setShowNovaSenha] = useState(false);
    const [showConfirmarSenha, setShowConfirmarSenha] = useState(false);
    const [showLoading, setShowLoading] = useState(false);
    const [tokenValido, setTokenValido] = useState(null);
    const [validandoToken, setValidandoToken] = useState(false);

    const notifyError = (mensagem) => toast.error(mensagem, { theme: "colored" });
    const notifySuccess = (mensagem) => toast.success(mensagem, { theme: "colored" });
    const notifyInfo = (mensagem) => toast.info(mensagem, { theme: "colored" });

    const validarSenhas = () => {
        if (!novaSenha || !confirmarSenha) {
            notifyError("Preencha todos os campos.");
            return false;
        }

        if (novaSenha.length < 6) {
            notifyError("A senha deve ter pelo menos 6 caracteres.");
            return false;
        }

        if (novaSenha !== confirmarSenha) {
            notifyError("As senhas não coincidem.");
            return false;
        }

        return true;
    };

    const handleRedefinirSenha = async () => {
        if (!validarSenhas()) return;

        try {
            setShowLoading(true);
            const tokenParam = token || searchParams.get('token');

            const response = await api.post('/recuperar-senha', {
                token: tokenParam,
                new_password: novaSenha,
                email: email
            });

            if (response.data.success) {
                notifySuccess("Senha redefinida com sucesso!");
                setTimeout(() => {
                    navigate('/login');
                }, 2000);
            } else {
                notifyError(response.data.mensagem || "Erro ao redefinir senha.");
            }
        } catch (error) {
            console.error("Erro ao redefinir senha:", error);
            notifyError(
                error.response?.data?.mensagem ||
                    "Não foi possível redefinir a senha. Tente novamente."
            );
        } finally {
            setShowLoading(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleRedefinirSenha();
        }
    };

    if (validandoToken) {
        return (
            <div id="container-nova-senha">
                <div id="container-central">
                    <div className="logo-wrapper">
                        <img src={sbfLogo} alt="SBF" id="img-logo" />
                    </div>
                    <div id="container-loading">
                        <FaSpinner className="fa-spin" size={40} color="#008c39" />
                        <p>Validando token...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (tokenValido === false) {
        return (
            <div id="container-nova-senha">
                <div id="container-central">
                    <div className="logo-wrapper">
                        <img src={sbfLogo} alt="SBF" id="img-logo" />
                    </div>
                    <div id="container-error">
                        <div className="error-icon">
                            <FaLock size={60} color="#e74c3c" />
                        </div>
                        <h3>Token Inválido</h3>
                        <p>O link de redefinição de senha é inválido ou expirou.</p>
                        <p>Redirecionando para o login...</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="container-nova-senha">
            <div id="container-central">
                <div className="logo-wrapper">
                    <img src={sbfLogo} alt="SBF" id="img-logo-nova-senha" />
                </div>

                <div id="header-nova-senha">
                    <div className="lock-icon">
                        <FaLock size={40} color="#008c39" />
                    </div>
                    <h2>Nova Senha</h2>
                    <p>Defina uma nova senha segura para sua conta</p>
                </div>

                <div id="container-inputs-nova-senha">
                    <div className="email-input-wrapper">
                        <input
                            type="email"
                            placeholder="Digite seu email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            onKeyPress={handleKeyPress}
                            disabled={showLoading}
                            className="email-input"
                        />
                    </div>
                    <div className="password-input-wrapper">
                        <input
                            type={showNovaSenha ? "text" : "password"}
                            placeholder="Nova senha (mín. 6 caracteres)"
                            value={novaSenha}
                            onChange={(e) => setNovaSenha(e.target.value)}
                            onKeyPress={handleKeyPress}
                            disabled={showLoading}
                            className="password-input"
                        />
                        <button
                            type="button"
                            className="password-toggle-btn"
                            onClick={() => setShowNovaSenha(!showNovaSenha)}
                            disabled={showLoading}
                            title={showNovaSenha ? "Ocultar senha" : "Mostrar senha"}
                        >
                            {showNovaSenha ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
                        </button>
                    </div>

                    <div className="password-input-wrapper">
                        <input
                            type={showConfirmarSenha ? "text" : "password"}
                            placeholder="Confirmar nova senha"
                            value={confirmarSenha}
                            onChange={(e) => setConfirmarSenha(e.target.value)}
                            onKeyPress={handleKeyPress}
                            disabled={showLoading}
                            className="password-input"
                        />
                        <button
                            type="button"
                            className="password-toggle-btn"
                            onClick={() => setShowConfirmarSenha(!showConfirmarSenha)}
                            disabled={showLoading}
                            title={showConfirmarSenha ? "Ocultar senha" : "Mostrar senha"}
                        >
                            {showConfirmarSenha ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
                        </button>
                    </div>

                    <button
                        className={`btn px-5 text-white mt-1 ${showLoading ? "bt-loading" : ""}`}
                        id="botao-redefinir"
                        onClick={handleRedefinirSenha}
                        disabled={showLoading}
                    >
                        {showLoading ? (
                            <>
                                <FaSpinner className="fa-spin me-2" />
                                Redefinindo...
                            </>
                        ) : (
                            <>
                                <FaCheck className="me-2" />
                                Redefinir Senha
                            </>
                        )}
                    </button>

                    <button
                        className="btn btn-link mt-2"
                        id="botao-voltar"
                        onClick={() => navigate('/login')}
                        disabled={showLoading}
                    >
                        Voltar ao Login
                    </button>
                </div>

                <div id="dicas-senha">
                    <h6>Dicas para uma senha segura:</h6>
                    <ul>
                        <li>Use pelo menos 6 caracteres</li>
                        <li>Combine letras, números e símbolos</li>
                        <li>Evite informações pessoais óbvias</li>
                        <li>Não reutilize senhas de outras contas</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default NovaSenha; 